'use strict';

var { camelizeKeys } = require('humps');

function normalizeError(res) {
  var err = new Error(res.text);
  err.status = res.status;
  err.body = res.body && camelizeKeys(res.body);

  return err;
}

module.exports = normalizeError;



/** WEBPACK FOOTER **
 ** ./utils/normalizeError.js
 **/